<template>
  <div class="rich-wrap">
    <el-dialog
      :show-close="false"
      destroy-on-close
      :close-on-click-modal="false"
      :title="`编辑${editObj.label}`"
      :visible.sync="dialogVisible"
      width="90%"
    >
      <div>
        <WangEditor :value.sync="richValue"></WangEditor>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="handleConfirm">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import WangEditor from "@/components/wangEditor";
export default {
  components: {
    WangEditor,
  },

  data() {
    return {
      dialogVisible: false,
      editObj: {},
      richValue: "",
      editId: "",
    };
  },

  computed: {},

  watch: {},

  mounted() {},

  methods: {
    showDialog(data, val, id) {
      this.editId = id;
      this.editObj = data;
      this.dialogVisible = true;
      this.richValue = val;
    },
    handleConfirm() {
      this.$emit("handleConfirm", this.richValue, this.editObj, this.editId);
      this.dialogVisible = false;
    },
  },
};
</script>

<style lang="less" scoped></style>
